"use client";

import React, { useState, useEffect } from "react";
import { Button, Dialog, DialogTitle, IconButton, useMediaQuery, useTheme } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SendIcon from "@mui/icons-material/Send";
import { HubspotFormFields } from "@/types/contentful/hubspot-form";
import HubspotEmbed from "@/components/forms/hubspot-embed";
import useHubspotEmbed from "@/hooks/forms/use-hubspot-embed";
import useScrollLock from "@/hooks/scroll-lock/use-scroll-lock";


interface EmailSignupProps {
  form: HubspotFormFields;
}
const EmailSignup = ({ form }: EmailSignupProps) => {

    const [open, setOpen] = useState(false);
    useScrollLock(open);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));
    const handleOpen = () => {
      setOpen(true);
    };

  const handleClose = () => {
    setOpen(false);
  };

  // Allow other components to open this modal via custom event
  useEffect(() => {
    const handleOpenEvent = () => setOpen(true);
    window.addEventListener("collette:open-email-signup", handleOpenEvent);
    return () => window.removeEventListener("collette:open-email-signup", handleOpenEvent);
  }, []);

  const targetId = `hubspotForm-${form.formId}-email-signup-form`;

  const {
    dataLayerProps
  } = useHubspotEmbed({
    formId: form.formId,
    portalId: form.portalId,
    formName: form.formName,
    targetId,
    instanceId: "email-signup"
  });

  return (
    <>
      <div className="d-inline-flex signup-btn"
        style={{
          right: "0",
          transform: "rotate(-90deg)",
          position: "fixed",
          top: "30rem",
          width: "30px",
          zIndex: "1111"
        }}>
        <Button data-testid="email-signup-flyout-button" className="btn btn-primary" data-toggle="modal"
          data-target="#email-signup"
          onClick={() => handleOpen()}
          sx={{
            borderBottom: "0px",
            backgroundColor: "secondary.main",
            borderRadius: "2.4rem",
            fontSize: "14px",
            fontWeight: "500",
            fontStretch: "normal",
            fontStyle: "normal",
            lineHeight: "normal",
            letterSpacing: "0.42px",
            textAlign: "left",
            color: "secondary.contrastText",
            padding: "1rem 2.5rem",
            whiteSpace: "nowrap",
            fontFamily: "Montserrat",
            textTransform: "none",
            borderBottomRightRadius: "0px",
            borderBottomLeftRadius: "0px"
          }}>
          <SendIcon sx={{ transform: "rotate(-45deg)", fontSize: "medium", marginRight: "7px" }} /> Email Signup
        </Button>
      </div>
      <Dialog id="email-signup" open={open} keepMounted
        maxWidth="sm"
        fullWidth
        fullScreen={isMobile}
        aria-modal="true"
        data-testid="email-signup-dialog"
        sx={{
          padding: "20px", marginRight: "auto", marginLeft: "auto", backgroundColor: isMobile ? "common.black" : "transparent"
        }}
        onClose={handleClose}>
        <DialogTitle sx={{ padding: "30px 15px 15px 40px", textAlign: "left", position: "relative", color: "text.primary", fontSize: "2.5rem", fontWeight: "600", backgroundColor: "common.white" }} data-testid="email-signup-dialog-title">
          {form.formTitle}
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (x) => x.palette.grey[500]
            }}
            data-testid="dialog-close-button">
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <HubspotEmbed
          formId={form.formId}
          dataLayerProps={dataLayerProps}
          targetId={targetId}
        />
      </Dialog>
    </>
  );
};

export default EmailSignup;